export enum Role {
  SUPER_ADMIN = 0,
  ADMIN = 1,
  MANAGER = 2,
  STAFF = 3,
}

export enum Permission {
  MANAGE_USERS = 'MANAGE_USERS',
  BILLING = 'BILLING',
}

export type User = {
  _id?: string;
  firstName: string;
  lastName?: string;
  email: string;
  role: Role;
  permissions: Permission[];
  organization?: string;
  jobRoles: string[];
  isVerified: boolean;
  pinNumber: string;
  proPicture: string;
};

// eslint-disable-next-line consistent-return
export function getRoleString(role?: Role): string {
  if (role == null) {
    return 'Unknown';
  }
  switch (role) {
    case Role.SUPER_ADMIN:
      return 'Super Admin';
    case Role.ADMIN:
      return 'Admin';
    case Role.MANAGER:
      return 'Manager';
    case Role.STAFF:
      return 'Staff';
  }
}
